const MarkdownIt = require("markdown-it");

const chatForm = document.querySelector("#chat-form");
const chatLog = document.querySelector("#chat-log");
const markdown = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: false,
});

function setBusy(form, busy) {
  const button = form.querySelector("button[type='submit']");
  if (!button) return;
  button.disabled = busy;
  button.dataset.originalText = button.dataset.originalText || button.textContent;
  button.textContent = busy ? "Working..." : button.dataset.originalText;
}

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

function appendMessage(role, text) {
  const item = document.createElement("article");
  item.className = `t47-chat-message t47-chat-message--${role}`;
  item.innerHTML = `
    <h2 class="t47-chat-message__sender">${role === "user" ? "You" : "Transparency47 AI"}</h2>
    <div class="t47-chat-message__body t47-markdown-body">${renderChatBody(role, text)}</div>
  `;
  chatLog.append(item);
  chatLog.scrollTo({ top: chatLog.scrollHeight, behavior: "smooth" });
}

function renderChatBody(role, text) {
  const value = String(text || "");
  if (role === "assistant") {
    return markdown.render(value);
  }
  return `<p>${escapeHtml(value).replaceAll("\n", "<br>")}</p>`;
}

async function fetchJson(url, options = {}) {
  const response = await fetch(url, options);
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.error || `Request failed with status ${response.status}`);
  }

  return payload;
}

chatForm?.addEventListener("submit", async (event) => {
  event.preventDefault();
  const question = new FormData(chatForm).get("question")?.toString().trim();
  if (!question) return;

  appendMessage("user", question);
  setBusy(chatForm, true);

  try {
    const payload = await fetchJson("/api/chat", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ question }),
    });
    appendMessage("assistant", payload.answer);
  } catch (error) {
    appendMessage("assistant", error.message);
  } finally {
    setBusy(chatForm, false);
    chatForm.reset();
  }
});
